import { useDispatch, useSelector } from 'react-redux'
import ConfirmModalV2 from '../../../components/ConfirmModalV2'
import styles from './VNTabPaymentMethodModal.module.scss'
import { getTabPaymentMethodModal } from '../../Selectors'
import { setTabPaymentMethodModal } from '../../ActionCreators'
import Button from '../../../components/Button'
import { APPLICATION_STRINGS } from '../../../strings'

export const VNTabPaymentMethodModal = () => {
  const dispatch = useDispatch()
  const props = useSelector(getTabPaymentMethodModal)

  if (!props?.open) {
    return null
  }

  const displayPreauthCards = () => {
    if (Array.isArray(props?.preAuthorizedCardName)) {
      return props.preAuthorizedCardName.map((payment) => (
        <Button
          onClick={() => {
            props?.handlePreAuthorizedCard?.(props?.newOrderDetails, props?.newOrderDetails?.tabName, payment)
          }}
          useMui
          key={payment?.[4]?.paymentId}
        >
          <span>{payment?.[1]}</span>
        </Button>
      ))
    }

    return (
      <Button
        useMui
        onClick={() => {
          props?.handlePreAuthorizedCard?.(props?.newOrderDetails, props?.newOrderDetails?.tabName)
        }}
      >
        <span>{props?.preAuthorizedCardName}</span>
      </Button>
    )
  }

  return (
    <ConfirmModalV2
      headerText={'Tab Payment Method'}
      classNames={{
        container: styles.confirmModalContainer,
        dialogContainer: props?.preAuthorizedCardName && props?.shouldShowAddPaymentLater && styles.dialogContainer,
        textBox: styles.textBox,
      }}
      emptyButtonContainer
      subtext={
        <div className={styles.tabButtonContainer}>
          {props?.preAuthorizedCardName && displayPreauthCards()}

          <Button
            useMui
            onClick={() => {
              props?.handleAuthorizePaymentRequest?.(props?.newOrderDetails)
              dispatch(setTabPaymentMethodModal({ open: false }))
            }}
          >
            <span>{props?.authNewText ? APPLICATION_STRINGS.AUTHORIZE_NEW_CARD : APPLICATION_STRINGS.AUTHORIZE_NOW}</span>
          </Button>

          {props?.shouldShowAddPaymentLater && (
            <Button
              useMui
              onClick={() => {
                props?.handleAddPaymentLater?.(props?.newOrderDetails, props?.newOrderDetails?.tabName)
                dispatch(setTabPaymentMethodModal({ open: false }))
              }}
            >
              <span>{APPLICATION_STRINGS.AUTHORIZE_LATER}</span>
            </Button>
          )}
        </div>
      }
      displayCloseButton
      onCloseButtonClick={() => {
        props?.handleClose?.()
        dispatch(setTabPaymentMethodModal({ open: false }))
      }}
    />
  )
}
